import React, { useState } from 'react';
import { Button, Modal, ModalBody, ModalFooter } from 'reactstrap';
import axios from 'axios'
import Photo from '../../images/photo.png'
import './modalImage.css'


const ModalImage = (props) => {
    const {
        className
    } = props;

    const [modal, setModal] = useState(false);

    const toggle = () => setModal(!modal);

    const [image, setImage] = useState()
    const [test, setTest] = useState('')

    const readUri = (e) => {
        let reader = new FileReader()
        reader.onload = (ev) => {
            setTest(ev.target.result)
        }
        reader.readAsDataURL(e.target.files[0]);
    }

    const onChangeHandler = (e) => {

        setImage(e.target.files)
        console.log(e.target.files[0])
        readUri(e)

    }

    const onClickHandler = (e) => {
        e.preventDefault()
        const data = new FormData()
        data.append('file', image[0])

        axios.post("https://clean-my-calanques.herokuapp.com/upload", data, image)
            .then(res => { props.setEvent({ ...props.event, url: res.data.url }) })
            .then(x => setModal(!modal))

            .catch(err => console.log(err))
            
    }   


    return (
        <div>
            <Button className="photoButton" onClick={toggle}><img src={Photo} width="30px" /></Button>
            <Modal isOpen={modal} toggle={toggle} className={className}>
                <ModalBody>
                    <form method="POST" encType="multipart/form-data" action="/upload" >
                        <div className="upload-btn-wrapper">
                            <button className="buttonUpload">Ajouter une photo !</button>
                            <input required type="file" name="file" onChange={(e) => onChangeHandler(e)} />
                        </div>
                    </form>
                    <img src={test} style={{ width: '300px', textAlign: 'center', borderRadius:'5px' }} />
                </ModalBody>
                <ModalFooter>
                    <Button className="btn" type="submit" onClick={toggle} onClick={(e) => onClickHandler(e)}>Envoyer</Button>{' '}
                </ModalFooter>
            </Modal>
        </div>
    );
}

export default ModalImage;